import * as React from "react";
import { observer } from "mobx-react";
import { useState } from "react";
import { Input, Form, message, Spin } from "antd";
import { title } from "../../style/header";
import { large } from "../../style/button";
import { css } from "@emotion/core";
import { Footer } from "../organisms/Footer";
import { ArrowLink } from "../atoms/ArrowLink";
import { arrowLinkContainer } from "../../style/layout";
import { longLabel } from "../../style/form";
import { apiEndpoint } from "../../util";

export const Signin = observer(() => {
  const [contact, setContact] = useState("");

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <h3 css={title}>お申込み(登録済)</h3>

      <Form
        labelCol={{ xs: { span: 24 }, sm: { span: 10 } }}
        wrapperCol={{ xs: { span: 24 }, sm: { span: 10 } }}
      >
        <Form.Item label="メールアドレスまたは電話番号(SMS)" css={longLabel}>
          <Input value={contact} onChange={e => setContact(e.target.value)} />
        </Form.Item>
      </Form>
      <div
        css={css`
          margin: 0 40px 40px;
        `}
      >
        <button
          css={large}
          disabled={loading}
          onClick={() => {
            setLoading(true);

            fetch(apiEndpoint("/postal/magic-link"), {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                ident: contact
              })
            }).then(
              response => {
                if (response.status >= 400) throw new Error("server error");
                message.success("ログインURLを送信しました");
                setLoading(false);
              },
              _ => {
                alert("エラーが発生しました");
                setLoading(false);
              }
            );
          }}
        >
          ログインURLを送信
          {loading && <Spin size="small" />}
        </button>
      </div>

      <div
        css={css`
          padding: 20px;
          border-radius: 10px;
          background: #f0f0f0;
          ${arrowLinkContainer}
        `}
      >
        ログインURLが届かない場合、大変お手数ですがご連絡ください。
        <br />
        support@postal.gift
      </div>

      <div css={arrowLinkContainer}>
        <ArrowLink to="/signup" direction="left">
          <div>
            未登録の方はこちら
            <br />
            <small>サンプル・資料請求済の方</small>
          </div>
        </ArrowLink>
      </div>

      <Footer />
    </div>
  );
});
